<template>
  <div>
    <!-- <Header /> -->

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="flex">
      <SideBar />

      <!-- {{  studentList }} -->

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <!-- {{ userSelectList }} -->
        <div
          class="px-10 py-10 flex items-center justify-end gap-10"
          v-if="this.userSelectList != 0"
        >
          <div class="flex items-center justify-end gap-5">
            <button
              class="bg-blues text-white px-5 py-2 rounded-2xl font-semibold text-sm hover:bg-hover transition-all duration-200"
              @click="addStudents"
            >
              Add Students
            </button>
          </div>
        </div>
        <div
          class="w-full overflow-x-auto rounded-lg border border-gray-200 shadow-sm"
        >
          <table class="min-w-full text-sm">
            <thead>
              <tr class="bg-gray-100">
                <th
                  class="py-3 px-4 border-b border-r font-semibold text-textblues text-center"
                  :class="{ 'border-t': this.userSelectList != 0 }"
                >
                  Select
                </th>
                <th
                  class="py-3 px-4 border-b border-r font-semibold text-textblues text-center"
                  :class="{ 'border-t': this.userSelectList != 0 }"
                >
                  S NO
                </th>
                <th
                  class="py-3 px-4 border-b border-r font-semibold text-textblues text-center"
                  :class="{ 'border-t': this.userSelectList != 0 }"
                >
                  Name
                </th>
                <th
                  class="py-3 px-4 border-b border-r font-semibold text-textblues text-center"
                  :class="{ 'border-t': this.userSelectList != 0 }"
                >
                  Email
                </th>
                <!-- <th
                class="py-3 px-4  border-b text-center border-r text-textblues"
                :class="{ 'border-t': this.userSelectList != 0 }"
              >
                Last login
              </th> -->
              </tr>
            </thead>
            <tbody
              v-if="loading"
              style="height: calc(100vh - 350px) !important"
            >
              <tr class="w-full">
                <td colspan="8" class="text-center py-6">
                  <div class="flex items-center justify-center">
                    <img src="@/assets/newd/loading.gif" alt="" />
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody
              v-else-if="studentList && !loading"
              class="divide-y divide-gray-100"
            >
              <tr
                v-for="(el, index) in this.studentList"
                :key="el.user.id"
                class="hover:bg-gray-50 transition"
              >
                <td class="py-3 px-4 border-b text-center border-r">
                  <!-- <p class="text-primary">{{ index + 1 }}</p> -->
                  <input
                    type="checkbox"
                    :value="el.user.id"
                    v-model="userSelectList"
                    name=""
                    id=""
                  />
                </td>

                <td
                  class="py-3 px-4 border-b text-center border-r text-blue-600 font-medium"
                >
                  {{ (currentPage - 1) * 10 + index + 1 }}
                </td>
                <td class="py-3 px-4 border-b text-center border-r">
                  <p v-if="el.user.display_name" class="text-gray-800">
                    {{ el.user.display_name }}
                  </p>
                  <p v-else class="text-gray-700">NA</p>
                </td>
                <td class="py-3 px-4 border-b text-center">
                  <p class="text-gray-700">{{ el.user.email }}</p>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr class="w-full">
                <td colspan="8" class="text-center py-6">
                  <div class="w-full flex justify-center items-center">
                    No Data Found
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <Pagination
          :totalPages="totalPages"
          ref="paginationRef"
          @page-changed="getstudentdetails"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";

import axios from "axios";
import { mapGetters } from "vuex";

import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    Header,
    SideBar,
    FlashMessage,
    Pagination,
  },
  data() {
    return {
      userSelectList: [],
      popUpAll: false,
      popupMailAll: false,
      popUp: false,
      minimize: true,
      maximize: false,
      studentList: null,
      mailid: null,
      messages: {
        text: "",
        type: "null",
      },
      loading: true,
      courseInfo: "",
      totalPages: 1,
      currentPage: 1,
    };
  },
  created() {
    this.getstudentdetails(1);
  },

  props: ["course_id", "department_id"],

  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    async addStudents() {
      await axios
        .post(
          `${process.env.VUE_APP_API}/assign-student-permission/?Key=${this.userInfo.token_key}`,
          {
            courses: [this.course_id],
            users: this.userSelectList,
          }
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            // this.$refs.mailrefbulk.reset();
            // this.popUpAll = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.userSelectList = [];
              this.getstudentdetails(1);
            }, 1500);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 1500);
          }
        });
    },

    async getstudentdetails(page) {
      this.currentPage = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/student/detail/list/?Key=${this.userInfo.token_key}&department__id=${this.department_id}&page=${page}&course_id=${this.course_id}`
        )
        .then((response) => {
          this.totalPages = response.data.total_page;
          this.studentList = response.data.data.data;
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
